'use strict';

module.exports = function (ngModule) {
    ngModule.directive('severityLevels', require('./severitylevels'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/severitylevels/index.js
 **/